// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2gT0d","actionsCol":"EnrolledClinics_actionsCol__1kjkj"};